module.exports = {
      id: "ic-countdown-dark-normal-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-countdown-dark-normal-usage",
      toString: function () {
        return this.url;
      }
    }